var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecuritySolutions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 525.21 434.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1f1f1;}.cls-2{fill:#fff;}.cls-3{fill:#e5e5e5;}.cls-4{fill:#e6e6e6;}.cls-5{fill:#cbcbcb;}.cls-6{fill:#f2f2f2;}.cls-7{fill:#6c63ff;}.cls-8{fill:#2f2e41;}.cls-9{fill:#3f3d56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ab2e16f2-9798-47da-b25d-769524f3c86f",
    className: "cls-1",
    x: 279.51,
    y: 64.85,
    width: 206.76,
    height: 98.11,
    transform: "translate(-12.35 55.91) rotate(-8.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bf81c03f-68cf-4889-8697-1102f95f97bb",
    className: "cls-2",
    x: 285.47,
    y: 73.26,
    width: 194.94,
    height: 81.86,
    transform: "translate(-12.39 55.92) rotate(-8.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f065dccc-d150-492a-a09f-a7f3f89523f0",
    className: "cls-3",
    x: 272.23,
    y: 59.71,
    width: 206.76,
    height: 8.78,
    transform: "translate(-5.31 54.36) rotate(-8.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ab2e16f2-9798-47da-b25d-769524f3c86f-2",
    className: "cls-4",
    x: 318.45,
    y: 92.35,
    width: 206.76,
    height: 98.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bf81c03f-68cf-4889-8697-1102f95f97bb-2",
    className: "cls-2",
    x: 324.36,
    y: 100.76,
    width: 194.94,
    height: 81.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f065dccc-d150-492a-a09f-a7f3f89523f0-2",
    className: "cls-5",
    x: 318.36,
    y: 86.68,
    width: 206.76,
    height: 8.78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-4",
    x: 436.69,
    y: 113.21,
    width: 27.45,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-4",
    x: 436.69,
    y: 119.27,
    width: 42.4,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    className: "cls-4",
    x: 437.13,
    y: 125.04,
    width: 34.55,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    className: "cls-4",
    x: 436.69,
    y: 131.37,
    width: 20.17,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    className: "cls-4",
    x: 436.69,
    y: 137.55,
    width: 30.44,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    className: "cls-4",
    x: 424.18,
    y: 112.56,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    className: "cls-4",
    x: 424.18,
    y: 118.62,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    className: "cls-4",
    x: 424.18,
    y: 124.39,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    className: "cls-4",
    x: 424.18,
    y: 130.72,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    className: "cls-4",
    x: 424.18,
    y: 136.9,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    className: "cls-4",
    x: 436.69,
    y: 143.77,
    width: 27.45,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    className: "cls-4",
    x: 436.69,
    y: 149.83,
    width: 42.4,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    className: "cls-4",
    x: 437.13,
    y: 155.6,
    width: 34.55,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    className: "cls-4",
    x: 436.69,
    y: 161.93,
    width: 20.17,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    className: "cls-4",
    x: 436.69,
    y: 168.11,
    width: 30.44,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    className: "cls-4",
    x: 424.18,
    y: 143.12,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    className: "cls-4",
    x: 424.18,
    y: 149.18,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    className: "cls-4",
    x: 424.18,
    y: 154.95,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    className: "cls-4",
    x: 424.18,
    y: 161.28,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    className: "cls-4",
    x: 424.18,
    y: 167.47,
    width: 3.36,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    className: "cls-4",
    x: 349.84,
    y: 159.96,
    width: 27.46,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    className: "cls-4",
    x: 346.16,
    y: 165.32,
    width: 34.55,
    height: 2.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-4",
    d: "M381.41,133.93A17.93,17.93,0,0,1,355,149.72h0a17.93,17.93,0,1,1,26.43-15.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-2",
    cx: 365.66,
    cy: 121.86,
    r: 8.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-2",
    d: "M379.39,146.52a41.52,41.52,0,0,1-27.76-.11h0l6-11.83h16.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-4",
    d: "M25.84,397a22.6,22.6,0,0,0,21.83-3.85c7.65-6.42,10-17,12-26.79l5.76-29-12.08,8.32c-8.69,6-17.57,12.16-23.58,20.82S21.12,387,26,396.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-6",
    d: "M26.87,432a116.81,116.81,0,0,1-1.62-26.93,42.3,42.3,0,0,1,8.17-22.2,36.75,36.75,0,0,1,9.47-8.59c1-.6,1.83.9.88,1.5a35,35,0,0,0-13.88,16.76,56.32,56.32,0,0,0-3,24.25c.32,4.94,1,9.85,1.66,14.76a.89.89,0,0,1-.61,1.06.87.87,0,0,1-1.07-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-7",
    d: "M269.15,240.11a6.8,6.8,0,0,1-2.84.67l-91.13,2.51a14.31,14.31,0,1,1-.62-28.61l91.13-2.5a7,7,0,0,1,7.12,6.81l.32,14.67a7,7,0,0,1-4,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-7",
    d: "M152.21,432.2H137.54a7,7,0,0,1-7-7V302.85a7,7,0,0,1,7-7h14.67a7,7,0,0,1,7,7V425.24A7,7,0,0,1,152.21,432.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-7",
    d: "M191.2,432.2H176.53a7,7,0,0,1-7-7V302.85a7,7,0,0,1,7-7H191.2a7,7,0,0,1,7,7V425.24A7,7,0,0,1,191.2,432.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-7",
    cx: 165.8,
    cy: 117.92,
    r: 50.74
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-8",
    d: "M183,339.28h-36.5a43.06,43.06,0,0,1-37.37-64.71l51-88.42a6.48,6.48,0,0,1,11.2,0l50,86.64A44.33,44.33,0,0,1,183,339.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-8",
    d: "M177.77,139.24a18.35,18.35,0,0,0,10.54-2.51,8.11,8.11,0,0,0,3.18-6,5.47,5.47,0,0,0-1.85-4.47,7,7,0,0,0-6.64-.95l2.68-19.63-2-.26-3.14,23.07,1.64-.75a6,6,0,0,1,6.16,0,3.54,3.54,0,0,1,1.15,2.89,6.14,6.14,0,0,1-2.36,4.5,16.42,16.42,0,0,1-9.42,2.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-8",
    x: 195.43,
    y: 107.31,
    width: 10.72,
    height: 1.99
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-8",
    x: 161.61,
    y: 107.31,
    width: 10.72,
    height: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-7",
    d: "M153.86,327.94a6.79,6.79,0,0,1-.66-2.84L150.69,234a14.31,14.31,0,0,1,28.61-.63l2.5,91.14A7,7,0,0,1,175,331.6l-14.67.32A7,7,0,0,1,153.86,327.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-8",
    d: "M161.09,80.42a29.29,29.29,0,0,0,26.29,12.19,22.86,22.86,0,0,0,20-17.92,29.52,29.52,0,0,0-7.76-26A45.26,45.26,0,0,0,172.82,36a66.77,66.77,0,0,0-52.06,16.32A63.61,63.61,0,0,0,104.15,74.6,62.47,62.47,0,0,0,99,101.54a68.08,68.08,0,0,0,22.37,48.65,64.31,64.31,0,0,0,5.38,4.21c1.57,1.11,3.07-1.48,1.51-2.58a63.94,63.94,0,0,1-25.65-43,59.59,59.59,0,0,1,14-48.1,65.48,65.48,0,0,1,45.53-22.19c17.46-.76,39.27,7,42.54,26.46a20.85,20.85,0,0,1-9.77,22.23,23.9,23.9,0,0,1-26.38-3.28,30.35,30.35,0,0,1-4.83-5C162.51,77.41,159.92,78.89,161.09,80.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "bdbbf39c-df25-4682-8b85-5a6af4a1bd14",
    className: "cls-2",
    cx: 257.28,
    cy: 7.14,
    r: 3.42
  }), /*#__PURE__*/React.createElement("circle", {
    id: "abcd4292-0b1f-4102-9b5e-e8bbd87baabc",
    className: "cls-2",
    cx: 270.15,
    cy: 5.28,
    r: 3.42
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a3fb731e-8b3d-41ca-96f2-91600dc0b434",
    className: "cls-2",
    cx: 283.02,
    cy: 3.42,
    r: 3.42
  }), /*#__PURE__*/React.createElement("circle", {
    id: "bdbbf39c-df25-4682-8b85-5a6af4a1bd14-2",
    className: "cls-2",
    cx: 351.99,
    cy: 34.78,
    r: 3.42
  }), /*#__PURE__*/React.createElement("circle", {
    id: "abcd4292-0b1f-4102-9b5e-e8bbd87baabc-2",
    className: "cls-2",
    cx: 365,
    cy: 34.78,
    r: 3.42
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a3fb731e-8b3d-41ca-96f2-91600dc0b434-2",
    className: "cls-2",
    cx: 378,
    cy: 34.78,
    r: 3.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-7",
    d: "M319.88,216.9c-17.87,0-32.41-15.44-32.41-34.42s14.54-34.42,32.41-34.42,32.4,15.44,32.4,34.42S337.75,216.9,319.88,216.9Zm0-60.14c-13.07,0-23.71,11.52-23.71,25.72s10.64,25.73,23.71,25.73,23.7-11.53,23.7-25.73S333,156.76,319.88,156.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-9",
    d: "M350.56,276.89H289.19a20.43,20.43,0,0,1-20.41-20.41v-60.2a14,14,0,0,1,14-14H357a14,14,0,0,1,14,14v60.2A20.44,20.44,0,0,1,350.56,276.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-2",
    d: "M331.84,216.55a12,12,0,1,0-17.4,10.64v18.72h10.88V227.2A12,12,0,0,0,331.84,216.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-9",
    d: "M380,434.78H.94a1,1,0,0,1,0-2H380a1,1,0,1,1,.1,2Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySolutions);
export default __webpack_public_path__ + "static/media/security-solutions.545887953ec87c94a1fc2bb27500b288.svg";
export { ForwardRef as ReactComponent };